import { Injectable } from "@angular/core";
import { CountsData, DgHubClientService, TrackedStrikeRequest, TrackedStrikes } from "../dg-hub-client.service";

@Injectable({
  providedIn: "root",
})
export class TrackedStrikesService {
  /**
   *
   */
  constructor(private dgCLientService: DgHubClientService) {

    this.dgCLientService.ReceiveTrackedStrikeTradeInfoListTick.subscribe((l) => {
      // console.log(l);
      this.updateStrikeTableFromCounts(l);
    })

  }


  public allTrackedStrikes: TrackedStrikes[];
  public UpdateSingleTrackedStrike(id: string) {


    var request = new TrackedStrikeRequest();
    request.strike = this.extractStrike(id);

    this.dgCLientService.setTrackedStrike(request).then((l) => {
      this.getAllTrackedStrikes();
    });

  }



  public getAllTrackedStrikes() {
    this.dgCLientService.getAllTrackedStrike().then((l) => {
      // console.log(l);
      this.allTrackedStrikes = l;
      var html = this.renderTrackedStrikesToHTML(this.allTrackedStrikes);
      jQuery(".strikePan").html(html);
    })
  }


  public extractStrike(id: string) {
    const input = id;
    const match = input.match(/(\d+)_/);
    const result = match ? match[1] : null;
    return result;
  }

  public hasStrike(strikeToCheck: string): boolean {
    //   console.log(this.allTrackedStrikes);
    if (this.allTrackedStrikes != undefined) {
      return this.allTrackedStrikes.some(s => s.strike === strikeToCheck);
    }
    return false;
  }

  public renderTrackedStrikesToHTML(strikes: TrackedStrikes[]): string {
    let html = `<table class="tracked-strikes-table">\n`;
  
    html += `
    <tr >
      <td class="label green"></td>
      <td class="ask call-ask">ask</td>
      <td class="bid call-bid">bid</td>
      <td class="strike center"></td>
      <td class="ask put-ask">ask</td>
      <td class="bid put-bid">bid</td>
      <td class="label red"P</td>
    </tr>\n`;
      
    for (const s of strikes) {
      const strike = s.strike;
  
      html += `
  <tr id="strike_${strike}">
    <td class="label green">C</td>
    <td class="ask call-ask">N/A</td>
    <td class="bid call-bid">N/A</td>
    <td class="strike center">${strike}</td>
    <td class="ask put-ask">N/A</td>
    <td class="bid put-bid">N/A</td>
    <td class="label red">P</td>
  </tr>\n`;
    }
  
    html += `</table>`;
    return html;
  }

  public updateStrikeTableFromCounts(data: CountsData[]): void {
    data.forEach(item => {
      const strike = item.strike.toString();
  
      // Wyciągamy "C" lub "P" z symbolu, np. "EW123 C5550"
      const parts = item.symbol.split(' ');
      if (parts.length !== 2) return;
  
      const optionType = parts[1][0]; // "C" lub "P"
  
      const askCellSelector = optionType === 'C' ? '.call-ask' : '.put-ask';
      const bidCellSelector = optionType === 'C' ? '.call-bid' : '.put-bid';
  
      const row = document.querySelector(`#strike_${strike}`);
      if (!row) return;
  
      const askCell = row.querySelector(askCellSelector);
      const bidCell = row.querySelector(bidCellSelector);
  
      if (askCell && item.askPrice != null && !isNaN(item.askPrice)) {
        askCell.textContent = item.askPrice.toFixed(2);
      }
  
      if (bidCell && item.bidPrice != null && !isNaN(item.bidPrice)) {
        bidCell.textContent = item.bidPrice.toFixed(2);
      }
    });
  }
  //     testAddStrike()
  //   {
  //     var request = new TrackedStrikeRequest();
  //     request.strike="5750";
  //     request.side="PUT";
  //     this.dgCLientService.setTrackedStrike(request).then(()=>{

  //     })
  //   }
}